import styled from 'styled-components';
import { breakpoints } from '@vfit/shared/themes';

export const ButtonWrapper = styled.div`
  padding-bottom: 46px;
  width: 280px;
  margin: auto;
  @media (min-width: ${breakpoints.tablet}) {
    padding-bottom: inherit;
  }
  @media (min-width: ${breakpoints.desktop}) {
    padding-bottom: inherit;
  }
`;
